import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { MessageService } from "../messaging/message.service";
import { JwtHttpClientService } from "../http/jwt-http-client.service";
import { AuthService } from "../auth/auth.service";
import { MessageSeverity } from "../messaging/message.model";
/**
 * Actively pings to determine the offline status
 */
export class HealthCheckService {
    constructor(http, messageService, authService) {
        this.http = http;
        this.messageService = messageService;
        this.authService = authService;
    }
    init() {
        this.initNextPoll();
    }
    /**
     * Indicates that the client is offline.
     */
    notifyOffline() {
        this.messageService.send({
            id: "offline",
            title: "wo.connection-status.message.offline",
            severity: MessageSeverity.Critical,
            value: 0
        });
    }
    notifyOnline() {
        this.messageService.complete("offline");
    }
    initNextPoll() {
        if (!this.polling) {
            this.polling = true;
            Observable.timer(HealthCheckService.POLL_DELAY).first().subscribe(() => this.ping());
        }
    }
    ping() {
        if (this.authService.isLoggedIn()) {
            this.http.getWithoutToken("/dataserver/ping").subscribe(() => {
                this.notifyOnline();
                this.polling = false;
                this.initNextPoll();
            }, () => {
                this.notifyOffline();
                this.polling = false;
                this.initNextPoll();
            });
        }
        else {
            this.notifyOnline();
            this.polling = false;
            this.initNextPoll();
        }
    }
}
HealthCheckService.POLL_DELAY = 60000;
HealthCheckService.decorators = [
    { type: Injectable },
];
/** @nocollapse */
HealthCheckService.ctorParameters = () => [
    { type: JwtHttpClientService, },
    { type: MessageService, },
    { type: AuthService, },
];
//# sourceMappingURL=health-check.service.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fedelta-pos/data-client/health-check/health-check.service.js
// module id = null
// module chunks = 